import React from "react";
import { FormInput } from "../FormInput";
import { FormSelect } from "../FormSelect";

export const CreatePricingForm = ({
    isPlanCreated,
    price,
    frequency,
    frequencyOptions,
    handleChangeCallback,
    productPricingType
}) => {
    return (
        <>
            <FormInput
                label="Price"
                name="price"
                type="text"
                inputOnChange={handleChangeCallback}
                value={price}
                formProps={{ isRequired: true }}
                padding={{base: "0 0 10px"}}
            />
            {
                productPricingType === "Subscription" ? 
                <FormSelect
                    formProps={{
                        isRequired: true,
                    }}
                    label="Frquency"
                    value={frequency}
                    selectOnChange={handleChangeCallback}
                    options={frequencyOptions}
                    name="frequency"
                    padding={{ base: "0" }}
                    isDisabled={isPlanCreated}
                /> : <></>
            }
        </>
    );
}